import { Typography } from "@repo/design-system";
import type { IMoleculeInformationSection } from "@/api/moleculeDetails";
import { LEFT_ALIGN_COLS } from "@/lib/columnDescriptions";

interface IMoleculeInformationTableProps {
  section: IMoleculeInformationSection;
}

export function MoleculeInformationTable({
  section,
}: IMoleculeInformationTableProps) {
  const gridStyle = {
    gridTemplateColumns: [
      ...section.items.slice(0, -1).map(() => "minmax(120px, max-content)"),
      "minmax(120px, auto)",
    ].join(" "),
  };

  return (
    <div className="flex flex-col gap-4 rounded-2xl border border-borderPrimary bg-backgroundSecondary p-5">
      <Typography
        variant="paragraph-l-semibold"
        className="text-contentPrimary">
        {section.displayName}
      </Typography>
      <div className="overflow-hidden rounded-xl border border-borderPrimary">
        <div className="overflow-x-auto">
          <div style={gridStyle} className="grid min-w-full">
            {section.items.map((item) => (
              <div
                key={`h-${item.displayName}`}
                className={`flex items-center border-b border-borderPrimary bg-backgroundSecondary px-4 py-3 ${
                  LEFT_ALIGN_COLS.has(item.displayName) ? "" : "justify-center"
                }`}>
                <Typography
                  variant="paragraph-m-semibold"
                  className="whitespace-nowrap text-b700">
                  {item.displayName}
                </Typography>
              </div>
            ))}
            {section.items.map((item) => (
              <div
                key={`v-${item.displayName}`}
                className={`flex items-center bg-backgroundPrimary px-4 py-3 ${
                  LEFT_ALIGN_COLS.has(item.displayName) ? "" : "justify-center"
                }`}>
                <div className="flex flex-col gap-1 py-0.5">
                  {item.value.map((v, i) => (
                    <Typography
                      key={i}
                      variant="paragraph-m-regular"
                      className="whitespace-nowrap text-contentPrimary">
                      {v || "—"}
                    </Typography>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
